// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1BRTw","title":"FrontImage_title__2uKcF"};